import React, { useEffect, useState } from "react";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import {
  HasInitValueBox,
  ModalRowContentContainer,
} from "../../../AlimTalk/AlimTalkModal";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import { useApi } from "../../../../../hooks/useApi";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import Loader from "../../../../DefaultStyles/Loader";
import { macroStateOptionList } from "../MacroStateChangeModal/macrostate";
import ConfirmBtn from "../../../../Button/ConfirmBtn";

interface Props extends DefaultModalCommonProps {
  userData: {
    uid: number;
    nickname: string;
    name: string;
  };
}

export default function UserMacroStateUpdateModal({
  closeEvent,
  userData,
  confirmEvent,
}: Props) {
  const { partyId } = useParams();

  const [state, setState] = useState<OptionType>({
    value: "",
    label: "매크로 상태 선택",
  });
  const [fetch, setFetch] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: fetch ? "party/macro" : undefined,
    data: {
      partyid: partyId ? +partyId ?? 0 : 0,
      uid: userData.uid ? userData.uid ?? 0 : 0,
      macro: state.value ? +state.value ?? 0 : 0,
      type: true,
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      if (confirmEvent) confirmEvent();
      closeEvent();
      toast.success(
        `${userData.uid}_${userData.name}_${userData.nickname} 님의 매크로 상태를 변경했어요`
      );
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "매크로 상태 변경에 실패했습니다.");
      setFetch(false);
    }
  }, [error]);

  return (
    <DefaultModalLayout
      modalTitle={"매크로 상태 변경하기"}
      closeEvent={() => closeEvent()}
      confirmEvent={() => closeEvent()}
      confirmBtnText={"닫기"}
      isMediumModal
      cancelBtn={<></>}
    >
      {/* 대상 */}
      <ModalRow>
        <ModalLabel>대상</ModalLabel>

        <ModalRowContentContainer>
          <HasInitValueBox>
            {userData.uid}_{userData.name}_{userData.nickname}
          </HasInitValueBox>
        </ModalRowContentContainer>
      </ModalRow>

      {/* 상태 선택 */}
      <ModalRow style={{ alignItems: "flex-start" }}>
        <ModalLabel>상태 선택</ModalLabel>

        <ModalRowContentContainer style={{ flexWrap: "wrap" }}>
          <DropDown
            dropdownValue={state}
            setDropDownValue={setState}
            boxWidth={330}
            optionList={macroStateOptionList(Boolean(false))}
          />

          <ConfirmBtn
            btnText="변경"
            btnColor="mint"
            isDisabled={state.value === ""}
            btnClickEvent={() => setFetch(true)}
          />
        </ModalRowContentContainer>
      </ModalRow>

      <>{loading && <Loader />}</>
    </DefaultModalLayout>
  );
}
